<ng-container *ngIf="recordsList$ | async as fragmentsList" [formGroup]="form">
    <ng-container *ngIf="profiles$ | async as profiles">
        <ng-container *ngFor="let profile of profiles">
            <sh-profile-input-fieldset
                [profile]="profile"
                [formGroup]="form"
                [records]="fragmentsList"
                [recordInheritance]="recordInheritance"
                [aiProfile]="aiProfile"
                [isBatchEdit]="isBatchEdit"
            ></sh-profile-input-fieldset>
        </ng-container>

        <sh-notification
            *ngIf="profiles.length === 0"
            [type]="notificationType.Error"
            [title]="'record-detail.notifications.no-profiles.title' | translate"
            [message]="'record-detail.notifications.no-profiles.message' | translate: { amount: fragmentsList.length }"
            [icon]="'delete'"
        ></sh-notification>
    </ng-container>
</ng-container>
